export const getApiPath = () => `${window.location.origin}/api/`;
